<template>
  <q-page class="ub-page">
    <div class="row items-center">
      <div class="col-md-10 offset-md-1 q-ma-lg">
        <div class="text-h3">Material Icons</div>
      </div>
    </div>
    <div class="row items-center">
      <div class="col-md-10 offset-md-1 q-ma-md">
        <div class="text-subtitle1">
          MDI icons by <a href="https://materialdesignicons.com/">https://materialdesignicons.com/</a>. See detailed documentation on using icons in Quasar at
          <a href="https://quasar.dev/style/icon">https://quasar.dev/style/icon</a>
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
export default {
  name: 'MaterialIcons',
  data() {
    return {};
  },
  watch: {},
  mounted() {},
  methods: {}
};
</script>
